import { computed } from 'vue';

import { ORGANIZATION, ORGANIZATION_USER } from '@/models/auth/permissions.enum';
import { useFlagStore } from '@/stores/flag';
import { useIdentityStore } from '@/stores/identity';

export function useListeningPermissions() {
  const identityStore = useIdentityStore();
  const flagStore = useFlagStore();

  const organizationCanAccessSocialListening = computed(() =>
    identityStore.guard(ORGANIZATION.LISTENING.CAN_ACCESS_SOCIAL_LISTENING),
  );

  const organizationUserCanAccessSocialListening = computed(() =>
    identityStore.guard(ORGANIZATION_USER.LISTENING.CAN_ACCESS_SOCIAL_LISTENING),
  );

  const canAccessSocialListening = computed(
    () =>
      organizationCanAccessSocialListening.value && organizationUserCanAccessSocialListening.value,
  );

  const canAccessYoutubeCompliance = computed(
    () => flagStore.ready && flagStore.flags.youtubeCompliance,
  );

  const hasAccessToPremiumAnalytics = computed(() => {
    const subscriptions = Object.values(identityStore.subscriptions?.brand ?? {}).flat();
    return subscriptions.some(
      (sub) =>
        (sub as { dhProduct?: { label?: string } } | undefined)?.dhProduct?.label ===
        'premium_analytics',
    );
  });

  const hasIntuitiveTopicCreation = computed(
    () => flagStore.ready && flagStore.flags.slIntuitiveTopicCreation,
  );

  const canAccessVisualSearch = computed(() => flagStore.ready && flagStore.flags.slVisualSearch);

  const hasTopicCreationFilters = computed(
    () => flagStore.ready && flagStore.flags.slTopicCreationFilters,
  );

  return {
    organizationCanAccessSocialListening,
    organizationUserCanAccessSocialListening,
    canAccessSocialListening,
    canAccessYoutubeCompliance,
    hasAccessToPremiumAnalytics,
    hasIntuitiveTopicCreation,
    canAccessVisualSearch,
    hasTopicCreationFilters,
  };
}
